<template>
  <div id="dashboard" class="container__inner">
    <header class="dashboard-welcome">
      <p v-if="!!myUser" class="dashboard-welcome__title">
        <strong>{{ myUser.name }}</strong> ({{ myUser.investmentLimit.type }})님,<br />
        펀다에이아이에 오신 것을 환영합니다!
      </p>
      <p class="dashboard-welcome__date">마이펀다 투자 현황을 확인하세요.</p>
    </header>

    <v-row class="dashboard-layout" no-gutters>
      <v-col cols="12" md="4" class="dashboard-left-wrapper">
        <DashboardLeft
          ref="dashboardLeft"
          :my-dashboard-data="myDashboardData"
        />
      </v-col>

      <v-col cols="12" md="8" class="dashboard-main-wrapper">
        <nav class="dashboard-menu" aria-label="마이펀다 메뉴">
          <router-link
            v-for="menu in myPageMenuList"
            :key="menu.value"
            :to="{ name: menu.value }"
          >
            {{ menu.text }}
          </router-link>
        </nav>

        <section class="dashboard-content">
          <router-view
            :key="$route.fullPath"
            :my-dashboard-data="myDashboardData"
            :withdraw-balance="withdrawBalance"
            :withdraw-balance-loading="isWithdrawBalanceLoading"
          />
        </section>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import { AuthTypes } from '@/store/types/auth'
import DashboardLeft from '@/components/myfunda/DashboardLeft'

const DASHBOARD_REFRESH_ROUTE_NAMES = [
  'myfunda-home',
  'myfunda-invest-board',
  'myfunda-invest-list',
  'myfunda-schedule',
]

export default {
  components: {
    DashboardLeft,
  },
  data() {
    return {
      myPageMenuList: [
        { value: 'myfunda-home', text: '마이홈' },
        { value: 'myfunda-invest-board', text: '투자현황' },
        { value: 'myfunda-invest-list', text: '투자내역' },
        { value: 'myfunda-schedule', text: '상환내역' },
        { value: 'myfunda-balance-deposit', text: '예치금 입출금' },
      ],
      myDashboardData: null,
    }
  },
  computed: {
    ...mapGetters('auth', {
      myProfile: AuthTypes.getters.GET_PROFILE,
      balance: AuthTypes.getters.GET_BALANCE,
      isWithdrawBalanceLoading: AuthTypes.getters.GET_BALANCE_LOADING,
    }),
    myUser() {
      return this.myProfile
    },
    withdrawBalance() {
      return this.balance ? this.balance.withdraw : 0
    },
  },
  created() {
    _seo({
      titles: ['마이펀다'],
    })
  },
  watch: {
    '$route.fullPath': {
      immediate: true,
      handler() {
        if (!DASHBOARD_REFRESH_ROUTE_NAMES.includes(this.$route.name)) return

        this.$nextTick(() => {
          if (this.$refs.dashboardLeft) {
            this.$refs.dashboardLeft.refreshDashboardData()
          }
        })
      },
    },
    myProfile: {
      immediate: true,
      handler(profile) {
        if (profile) {
          this.fetchData(profile)
        }
      },
    },
  },
  methods: {
    fetchData(profile) {
      this.myDashboardData = {
        user: {
          ...profile,
        },
      }
    },
  },
}
</script>

<style lang="scss">
.v-application {
  background-color: #f4f6f9 !important;
}

.dashboard-box,
.dashboard-box--ma-0,
.dashboard-box--pa-0 {
  background-color: #fff !important;
  border: 1px solid #e6eaef;
  border-radius: 14px;
}

.dashboard-box {
  margin-top: 15px;
  margin-bottom: 15px;
  padding: 25px;
}

.dashboard-box--ma-0 {
  padding: 25px;
}

.dashboard-box--pa-0 {
  margin-top: 15px;
  margin-bottom: 15px;
}

.fade1-enter-active,
.fade1-leave-active {
  transition: opacity 0.1s;
}

.fade1-enter,
.fade1-leave-to {
  opacity: 0;
}

.list-card__title {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.sub-menu {
  button {
    width: 100%;
    max-width: 180px;
    padding: 10px;
    border: 0;
    border-radius: 22.5px;
    outline: none;
    background-color: #ffffff;
    color: #8a94a2;
    font-size: 16px;
    font-weight: 900;

    &:not(:last-child) {
      margin-right: 20px;

      @media screen and (min-width: 992px) and (max-width: 1200px) {
        margin-right: 15px;
      }
    }

    @media screen and (min-width: 960px) and (max-width: 1264px) {
      max-width: 160px;
    }

    &.router-link-exact-active {
      background-color: #f2f9ff;
      color: #1baaf1;
    }
  }

  &.mobile button {
    width: 33%;
    max-width: 130px;
    margin-right: 0 !important;
    padding: 10px 0;

    @media screen and (max-width: 359px) {
      font-size: 14px;
    }
  }
}

#dashboard {
  margin-top: 54px;
  margin-bottom: 80px;

  .dashboard-welcome {
    margin: 0 6px 30px;
  }

  .dashboard-welcome__title {
    margin: 0;
    color: #162235;
    font-size: 23px;
    font-weight: 500;
    line-height: 1.48;
    letter-spacing: -0.035em;
  }

  .dashboard-welcome__title strong {
    font-weight: 700;
  }

  .dashboard-welcome__date {
    margin: 8px 0 0;
    color: #8d98a6;
    font-size: 14px;
  }

  .dashboard-layout {
    align-items: flex-start;
    margin: 0 -10px;
  }

  .dashboard-left-wrapper,
  .dashboard-main-wrapper {
    padding: 0 10px;
  }

  .dashboard-left-wrapper {
    z-index: 1;
  }

  .dashboard-main-wrapper {
    min-width: 0;
  }

  .dashboard-menu {
    min-height: 64px;
    padding: 6px;
    display: flex;
    align-items: stretch;
    background: #fff;
    border: 1px solid #e6eaef;
    border-radius: 14px;
  }

  .dashboard-menu > a {
    flex: 1 1 0;
    min-width: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0 6px;
    color: #5a6675;
    border-radius: 9px;
    font-size: 14px;
    font-weight: 500;
    text-align: center;
    text-decoration: none;
    white-space: nowrap;
    transition: background-color 0.15s, color 0.15s;
  }

  .dashboard-menu > a:hover {
    background: #f7f9fb;
    color: #1a2330;
  }

  .dashboard-menu > a.router-link-active,
  .dashboard-menu > a.router-link-exact-active {
    background: #00ade5;
    color: #fff;
    font-weight: 700;
  }

  .dashboard-content {
    margin-top: 20px;
  }
}

@media screen and (max-width: 959px) {
  .dashboard-box,
  .dashboard-box--pa-0 {
    margin-top: 10px !important;
    margin-bottom: 5px !important;
  }

  #dashboard {
    margin-top: 28px;
    margin-bottom: 48px;
    padding: 0 14px;

    .dashboard-welcome {
      margin: 0 4px 24px;
    }

    .dashboard-welcome__title {
      font-size: 20px;
    }

    .dashboard-welcome__date {
      font-size: 13px;
    }

    .dashboard-layout {
      margin: 0 -7px;
    }

    .dashboard-left-wrapper,
    .dashboard-main-wrapper {
      padding: 0 7px;
    }

    .dashboard-main-wrapper {
      margin-top: 24px;
    }

    .dashboard-menu {
      min-height: 58px;
      overflow-x: auto;
      border-radius: 12px;
      scrollbar-width: none;
    }

    .dashboard-menu::-webkit-scrollbar {
      display: none;
    }

    .dashboard-menu > a {
      flex: 0 0 auto;
      padding: 0 16px;
      font-size: 13px;
    }

    .dashboard-content {
      margin-top: 18px;
    }
  }
}
</style>
